import { useQuery, UseQueryOptions } from 'react-query';
import api from '@API/api';

interface PanelInstanceResponse {
  instanceId: string;
  projectId: string;
  templateId: string;
  templateRevisionId: number;
  latestRevisionId: number;
  userSkippedVersion: number;
  instanceName: string;
  queryBuilderId: string;
  useDefaultConfig: boolean;
  metadata: {
    isStatic: boolean;
  };
  config: string;
  lastUpdate: number;
  createdAt: number;
  source: string;
}

interface GetPanelInstanceParams {
  instanceId: string;
}

const getPanelInstance = async ({
  instanceId
}: GetPanelInstanceParams): Promise<PanelInstanceResponse> => {
  return api.get('code-visualizations/instance/get', { instanceId });
};

export default function usePanelInstance(
  { instanceId }: GetPanelInstanceParams,
  config?: UseQueryOptions<PanelInstanceResponse>
) {
  const enabled = Boolean(instanceId);

  return useQuery<PanelInstanceResponse>(
    ['panelInstance', { instanceId }],
    () => getPanelInstance({ instanceId }),
    { enabled, ...config }
  );
}
